import React from 'react';
//components
import DesktopTable from './components/desktop';
import Pagination from './components/pagination';

const Table = props => {
  const { pagination, dataSource, columns, loading, action, sort } = props;

  return (
    <div className='tableContainer'>
      <DesktopTable
        dataIndex={dataSource}
        columns={columns}
        loading={loading}
        currentPage={pagination?.currentPage}
        pageSize={pagination?.pageSize}
        action={action}
        sort={sort}
      />
      {!loading && pagination && pagination.currentPage && pagination.totalCount && pagination.pageSize && (
        <Pagination
          currentPage={pagination.currentPage}
          pageSize={pagination.pageSize}
          totalCount={pagination.totalCount}
          onPageChange={pagination?.onPageChange}
        />
      )}
    </div>
  );
};

Table.defaultProps = {
  loading: false,
};

export default Table;
